import type { FaireProductEntity } from "../../entity_types/product";

export const p_n7p2khkbjk: FaireProductEntity = {
  token: "p_n7p2khkbjk",
  type: "product",
  name: "Mt. Angel Vitamins' Sleepy Sleep - 60 Capsules",
  brandToken: "b_33c1ec6d",
  brandName: "Mt. Angel Vitamins",
  imageUrl:
    "https://cdn.faire.com/fastly/523f38309d174dd6e3cd14b9f4a1e7b2eb5af1a300698133f94236113aa003f5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0647c768b2d27ef7070fd2f7eb731be9ff6df7b53919101f4f4ebb9e679b8c21.png",
    "https://cdn.faire.com/fastly/89c6aeddc46f2842a50b388271800bae690955c9a0be6dc145ca2c1a948e9da7.png",
    "https://cdn.faire.com/fastly/91df669f3baaed85f5a1c1d741ae3c2ea698ed4aa1de0f3ec05ef654ef58be6a.png",
    "https://cdn.faire.com/fastly/cffddcc7b51436ca0c176ada317237e29e13fc62094e26344354f0d47c182794.png",
    "https://cdn.faire.com/fastly/981a6e4007b965471946cced2f41202d2f97cff5d9788871a261efb700a685e3.png",
    "https://cdn.faire.com/fastly/fd019bcb54ee9f7e07a2ae984b70a8d91e4705d941d1789d77dcbe32524aaf1b.png",
  ],
  priceDollars: 11.99,
  description:
    "- Restful Nights, Refreshed Days - Sleepy Sleep helps you have a natural, peaceful, and deep sleep without waking up groggy in the morning. Wake up rejuvenated, energized, and confident every day so you’ll always be at your best performance. \n\n- Vegan Formulation - Nature’s wonders found in Sleepy sleep not only function as a sleeping aid but also prove to be potential relaxants. Magnesium, passion flowers, 5-HTP relax your mind and body for bedtime, and Melatonin, Hop extract, Lemon Balm, Chamomile rejuvenate a healthy sleep-wake cycle. \n\n- Non-Habitual - Our midnight sleep aid is a non-addictive vegan composition, unlike other sleeping pills for adults, 60 lime-flavored, easy-to-swallow capsules help you establish a natural sleep routine.",
  tags: [],
  msrpDollars: 23.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:23.419Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
